import { type Carer, Responsibility } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

export const checkSafeguardingAccess = (
  user: Carer | null | undefined
): boolean | undefined => {
  return user?.permissions?.some(
    (permission) => permission === Responsibility.SafeguardingOfficer
  )
}

const useSafeguardingAccess = (): boolean | undefined => {
  const user = useSelector(
    (state: { global: { user: Carer } }) => state.global.user
  )

  return checkSafeguardingAccess(user)
}

export default useSafeguardingAccess
